import { useCallback, useEffect, useRef } from 'react';
import { useSetAtom } from 'jotai';
import type { FileSizeFilterModel } from './types';
import { dashboardFilterAtom } from '../../filterAtom';

export const useFileSizeFilter = (model: FileSizeFilterModel | null) => {
  const setDashboardFilter = useSetAtom(dashboardFilterAtom);
  const previousModelReference = useRef<FileSizeFilterModel | null>(null);

  const updateAtom = useCallback(
    (newModel: FileSizeFilterModel | null) => {
      if (!newModel) {
        setDashboardFilter((previousFilter) => ({
          ...previousFilter,
          fileSizeLess: undefined,
          fileSizeMore: undefined,
        }));
        return;
      }

      setDashboardFilter((previousFilter) => ({
        ...previousFilter,
        fileSizeLess: newModel.fileSizeLess,
        fileSizeMore: newModel.fileSizeMore,
      }));
    },
    [setDashboardFilter]
  );

  useEffect(() => {
    const hasModelChanged =
      JSON.stringify(model) !== JSON.stringify(previousModelReference.current);

    if (hasModelChanged) {
      updateAtom(model);
      previousModelReference.current = model;
    }
  }, [model, updateAtom]);
};

